"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const store_1 = require("store");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const kendo_react_dateinputs_1 = require("@progress/kendo-react-dateinputs");
const rfid_log_style_1 = __importDefault(require("../rfid-log.style"));
const rfid_log_action_1 = __importDefault(require("../rfid-log.action"));
const rfid_log_column_1 = __importDefault(require("../rfid-log.column"));
const grid_1 = __importDefault(require("components/templates/grid"));
const authorization_1 = require("utils/authorization");
const modal_1 = require("components/molecules/modal");
const header_menu_1 = __importDefault(require("components/molecules/header-menu"));
const moment_1 = __importDefault(require("moment"));
const RfidLog = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { appTheme } = (0, store_1.useAppSelector)(state => state.app);
    const { userData } = (0, store_1.useAppSelector)(state => state.auth);
    const { isError, dataGrid, isLoading, dataStates, errorMessage, dataDropdownArea, dataDropdownPos, dataGridExcel } = (0, store_1.useAppSelector)(state => state.adjustment.rfid);
    const isAuthorized = (0, authorization_1.userRoleAuth)(userData.authorization, 'Adjustment', 'RFID Log');
    const _export = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (isAuthorized.view) {
            dispatch(rfid_log_action_1.default.getDataDropdownArea());
        }
        else {
            navigate('/dashboard', { replace: true });
        }
    }, [isAuthorized.view]);
    const excelExport = () => {
        if (_export.current !== null) {
            _export.current.save(dataGridExcel);
        }
    };
    const onDataStateChange = (types, val) => {
        const newDataStates = Object.assign(Object.assign({}, dataStates), { skip: types === 'page' ? (val - 1) * dataStates.take : 0, take: types === 'take' ? val : dataStates.take });
        handleFilter(newDataStates);
        dispatch(rfid_log_action_1.default.onDataStateChange(newDataStates));
    };
    const onFilterChange = (e) => {
        const newDataStates = Object.assign(Object.assign({}, dataStates), { filter: e.filter });
        handleFilter(newDataStates);
        dispatch(rfid_log_action_1.default.onFilterChange(e.filter));
        dispatch(rfid_log_action_1.default.onDataStateChange(newDataStates));
    };
    const handleChangeArea = ({ value }) => {
        const area = value;
        const newDataStates = Object.assign(Object.assign({}, dataStates), { area: area.value, description: '', checkpoint_id: '', checkpoint_type_id: area.id });
        dispatch(rfid_log_action_1.default.onDataStateChange(newDataStates));
        dispatch(rfid_log_action_1.default.getDataDropdownPos(newDataStates));
    };
    const handleChangePos = ({ value }) => {
        const pos = value;
        const newDataStates = Object.assign(Object.assign({}, dataStates), { checkpoint_id: pos.id, description: pos.description });
        dispatch(rfid_log_action_1.default.onDataStateChange(newDataStates));
    };
    const handleChangeDate = ({ value }) => {
        const newDataStates = Object.assign(Object.assign({}, dataStates), { end_date: value.end, start_date: value.start });
        dispatch(rfid_log_action_1.default.onDataStateChange(newDataStates));
    };
    const customFilterCell = () => {
        return ((0, jsx_runtime_1.jsx)(kendo_react_dateinputs_1.DateTimePicker, { value: dataStates.scan_date, onChange: (e) => {
                const newDataStates = Object.assign(Object.assign({}, dataStates), { scan_date: e.value });
                handleFilter(newDataStates);
                dispatch(rfid_log_action_1.default.onDataStateChange(newDataStates));
            } }));
    };
    const columnsRender = rfid_log_column_1.default.map(item => {
        if (item.field === 'scan_date') {
            return Object.assign(Object.assign({}, item), { locked: true, filterCell: customFilterCell });
        }
        return item;
    });
    const onClickGetRfidData = () => {
        var _a, _b;
        // Validate if start_date & end_date value are the same
        const start_date = dataStates.start_date;
        const end_date = ((_a = dataStates.start_date) === null || _a === void 0 ? void 0 : _a.getTime()) === ((_b = dataStates.end_date) === null || _b === void 0 ? void 0 : _b.getTime())
            ? (0, moment_1.default)(dataStates.end_date).add(1, 'days').subtract(1, 'seconds')
            : dataStates.end_date;
        const payload = {
            skip: dataStates.skip,
            take: dataStates.take,
            filter: {
                logic: 'and',
                filters: [
                    { field: 'scan_date', operator: 'lte', value: end_date },
                    { field: 'scan_date', operator: 'gte', value: start_date },
                    { field: 'checkpoint_id', operator: 'eq', value: dataStates.checkpoint_id },
                ]
            }
        };
        const payloadExcel = {
            skip: 0,
            take: 1000000,
            filter: {
                logic: 'and',
                filters: [
                    { field: 'scan_date', operator: 'lte', value: end_date },
                    { field: 'scan_date', operator: 'gte', value: start_date },
                    { field: 'checkpoint_id', operator: 'eq', value: dataStates.checkpoint_id },
                ]
            }
        };
        dispatch(rfid_log_action_1.default.getDataGrid(payload));
        dispatch(rfid_log_action_1.default.getDataGridExcelExport(payloadExcel));
        dispatch(rfid_log_action_1.default.onToggleLoading({ isLoading: true }));
    };
    const handleFilter = (dataStates) => {
        var _a, _b;
        const start_scan_date = new Date((0, moment_1.default)(dataStates.scan_date).add(1, 'seconds').toString());
        const end_scan_date = dataStates.scan_date;
        const filter_scan_date = [
            { field: 'scan_date', operator: 'lte', value: start_scan_date },
            { field: 'scan_date', operator: 'gte', value: end_scan_date },
            { field: 'checkpoint_id', operator: 'eq', value: dataStates.checkpoint_id },
        ];
        // Validate if start_date & end_date value are the same
        const start_header_date = dataStates.start_date;
        const end_header_date = ((_a = dataStates.start_date) === null || _a === void 0 ? void 0 : _a.getTime()) === ((_b = dataStates.end_date) === null || _b === void 0 ? void 0 : _b.getTime())
            ? (0, moment_1.default)(dataStates.end_date).add(1, 'days').subtract(1, 'seconds')
            : dataStates.end_date;
        const filter_header_date = [
            { field: 'scan_date', operator: 'lte', value: end_header_date },
            { field: 'scan_date', operator: 'gte', value: start_header_date },
            { field: 'checkpoint_id', operator: 'eq', value: dataStates.checkpoint_id },
        ];
        // Define filter object
        const filter = dataStates.filter
            ? {
                logic: 'and',
                filters: dataStates.scan_date
                    ? dataStates.filter.filters.concat(filter_scan_date)
                    : dataStates.filter.filters.concat(filter_header_date)
            }
            : { logic: 'and', filters: filter_header_date };
        const payload = {
            filter: filter,
            skip: dataStates.skip,
            take: dataStates.take,
        };
        dispatch(rfid_log_action_1.default.getDataGrid(payload));
        dispatch(rfid_log_action_1.default.onToggleLoading({ isLoading: true }));
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(header_menu_1.default, { theme: appTheme, title: 'RFID Log', isRfidLog: true, valueDate: {
                    end: dataStates.end_date,
                    start: dataStates.start_date,
                }, isLoading: isLoading, handleChangeDate: handleChangeDate, onSelectDropdownPos: handleChangePos, dataDropdownPosRfid: dataDropdownPos, onClickGetRfidData: onClickGetRfidData, onSelectDropdownArea: handleChangeArea, dataDropdownAreaRfid: dataDropdownArea, valueDropdownAreaRfid: dataDropdownArea.find((i) => i.value === dataStates.area), valueDropdownPosRfid: dataDropdownPos.find((i) => i.description === dataStates.description), dataGridRfidLog: dataGrid, onExportToExcel: excelExport }), (0, jsx_runtime_1.jsx)(modal_1.ModalError, { appTheme: appTheme, style: { 'zIndex': 10 }, errorMessage: errorMessage, show: isError, onClose: () => {
                    dispatch(rfid_log_action_1.default.onClickMutation({ mutationMode: false }));
                    dispatch(rfid_log_action_1.default.onToggleError({ isError: false, errorCode: 0, errorMessage: '' }));
                } }), (0, jsx_runtime_1.jsx)(grid_1.default, { pageable: true, sortable: false, dataGrid: dataGrid, sort: dataStates.sort, columns: columnsRender, dataStates: dataStates, style: rfid_log_style_1.default.gridHeight, onFilterChange: onFilterChange, onPageChange: v => onDataStateChange('page', v), onTakeChange: v => onDataStateChange('take', v), exportExcel: _export, fileNameExcel: 'Rfid_Log_' +
                    (0, moment_1.default)(dataStates.start_date).format('DDMMYYYY') +
                    '-' + (0, moment_1.default)(dataStates.end_date).format('DDMMYYYY') })] }));
};
exports.default = RfidLog;
